import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { isLogin, isWeworkUser } from 'utils';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { isCloudSlide } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import {
    IAiControllerInjectable,
} from '@src/slide/application/service/ai-controller/inject/ai-controller-Injectable.interface';

export default class AiControllerInjectable implements IAiControllerInjectable {
    public checkIsSupportAI(): boolean {
        // 本地编辑
        if (ENV.IS_LOCAL_EDIT) return false;
        // 云文档
        if (isCloudSlide()) return false;
        // 用户态：未登录、企微用户、只读用户
        if (!isLogin() || isWeworkUser()) return false;

        return true;
    }

    /** 是否为只读权限用户 */
    public isPreviewOnly = () => {
        const readable = SlideDataServices.PrivilegeManager()?.readable;
        const editable = SlideDataServices.PrivilegeManager()?.editable;
        return !!readable && !editable;
    };
}
